export default __webpack_public_path__ + "static/media/57_photo.ca06236a.jpg";